<app-charging></app-charging>

<div class="modal-overlay" *ngIf="isVisible">
  <div class="modal-content"> 
    <div class="role-name">{{roleName}}</div>
    <h2>{{title | titlecase}}</h2>
    <div class="divider"></div>
  

    <div class="upload-container">
      <label for="file-upload" class="upload-button">
        <i class="fas fa-cloud-upload-alt"></i>
        <span class="upload-text">Seleccione el archivo a cargar</span>
        <p class="allowed-types">
          <i class="fas fa-info-circle"></i>
          Tipos de archivo permitidos
          <span class="file-types">JPG, PNG, GIF, TIFF, BMP, PDF, DOC, DOCX</span>
        </p>
        <div class="max-size-info">
          <i class="fas fa-info-circle"></i>
          Peso máximo para visualizar el documento 1.5MB
        </div>
      </label>
      <input 
        type="file" 
        id="file-upload" 
        (change)="onFileSelected($event)"
        accept=".jpg,.jpeg,.png,.gif,.tiff,.bmp,.pdf,.doc,.docx"
      />
      <p class="file-info" *ngIf="selectedFile">
        <span>Archivo seleccionado: {{selectedFile.name}}</span>
        <button class="preview-button" (click)="showPreview = true">
          <i class="fas fa-eye"></i>
        </button>
      </p>
    </div>

    <div class="button-container">
      <button class="secondary-button" (click)="closeModal()">
        Cancelar
      </button>
      <button 
      class="primary-button" 
      (click)="onSave()"
      [disabled]="!selectedFile || isSaving">
      Cargar
    </button>
    </div>
  </div>
</div>

<app-document-preview
  [isVisible]="showPreview"
  [file]="selectedFile"
  (close)="showPreview = false">
</app-document-preview>